import { createFileRoute } from '@tanstack/react-router'
import { ProcessFlowDiagramBuilderPage } from 'pages/processFlows/ProcessFlowDiagramBuilderPage'
import { processFlowDiagramSearchParams } from 'routes/process-flows/-searchParams'

const RouteComponent = () => {
  const { siteId, diagramId } = Route.useSearch()

  return <ProcessFlowDiagramBuilderPage siteId={siteId} diagramId={diagramId} />
}

export const Route = createFileRoute('/process-flows/diagram')({
  component: RouteComponent,
  validateSearch: processFlowDiagramSearchParams,
  staticData: {
    title: 'Process Flow Diagram',
  },
})
